<p-toast key="global-error"></p-toast>
<div class="flex flex-column layout-wrapper">
  <div *ngIf="enableSidebar">
      <div class="w-full text-right">
        <p-button label="Logout" icon="pi pi-power-off" [text]="true" (onClick)="logout()" [loading]="logoutInProcess"></p-button>
      </div>
      <div class="layout-sidebar" [class.active]="sidebarVisible">
      <div class="sidebar-header">
        <!-- This button is only visible when sidebar is shown -->
        <button #toggleSidebarButton pButton icon="pi pi-bars" class="p-button-text sidebar-toggle" (click)="toggleSidebar()"></button>
      </div>
      <p-panelMenu #panelMenu [model]="menuItems" [style]="{'width':'100%'}"></p-panelMenu>

      <div class="menu-toggle-container">
        <button #toggleMenuExpansionButton
                pButton
                [icon]="menuExpanded ? 'pi pi-angle-double-up' : 'pi pi-angle-double-down'"
                [label]="menuExpanded ? 'Collapse Menu' : 'Expand Menu'"
                      (click)="toggleMenuExpansion()"
                pTooltip="Toggle menu items expansion" tooltipPosition="right"></button>
      </div>


    </div>
    <!-- Add persistent toggle button that's visible when sidebar is hidden -->
    <button *ngIf="!sidebarVisible" pButton icon="pi pi-bars" class="p-button-text sidebar-show-button" (click)="toggleSidebar()"></button>
  </div>
  <div class="layout-main" [class.ml-0]="!enableSidebar">
    <div class="layout-content">
      <router-outlet *ngIf="environment.buildMode === 'serve'"></router-outlet>
    </div>
  </div>
</div>
